<template>
  <div :class="['alignment-selector', { 'alignment-selector--disabled': disabled }]">
    <div
      v-for="alignment in alignments"
      :key="alignment"
      :class="[
        'alignment-selector__item',
        { 'alignment-selector__item--selected': selectedAlignment === alignment }
      ]"
      @click="emits('alignmentSelected', alignment)"
    >
      <div
        :class="['alignment-selector__detail-container', `alignment-selector__detail-container--${alignment}`]"
      >
        <hr class="alignment-selector__line-detail" style="width: 24px;">
        <hr class="alignment-selector__line-detail" style="width: 10px;">
        <hr class="alignment-selector__line-detail" style="width: 16px;">
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { TextAlign } from '@/types'

const alignments: TextAlign[] = ['left', 'center', 'right']

const props = defineProps<{
  selectedAlignment: TextAlign | null,
  disabled: boolean
}>()

const emits = defineEmits<{
  (event: 'alignmentSelected', alignment: TextAlign): void
}>()
</script>
<style lang="scss">
.alignment-selector {
  $root: #{&};
  display: flex;
  flex-direction: row;
  gap: 6px;

  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 40px;
    background-color: $button-grey;
    border-radius: 2px;
    cursor: pointer;
    transition: background-color 150ms $animationCurve;

    &:hover {
      background-color: $grey-80
    }

    &--selected {
      &, &:hover {
        background-color: $button-grey;
        border: 2px solid $white;
      }
    }
  }

  &__detail-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;

    &--left {
      align-items: flex-start;
    }

    &--center {
      align-items: center;
    }

    &--right {
      align-items: flex-end;
    }
  }

  &__line-detail {
    margin: 0px;
    background-color: $white;
    border: 1.5px solid $white;
  }

  &--disabled {
    pointer-events: none;

    #{$root}__line-detail {
      background-color: $grey-80;
      border-color: $grey-80;
    }
  }
}
</style>